import React, { useState } from 'react';
import axios from 'axios';
import { setKey } from '../services/auth';

const getBaseUrl = () => process.env.REACT_APP_API_URL || '/api';

function Login({ onLogin }) {
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!apiKey.trim()) return;
    setLoading(true);
    setError(null);
    try {
      await axios.get(`${getBaseUrl()}/auth/verify`, {
        headers: { 'X-API-Token': apiKey.trim() }
      });
      setKey(apiKey.trim());
      onLogin();
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Invalid API key.');
      } else {
        setError('Could not connect to server. Is it running?');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        background: 'white', borderRadius: '1rem',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        padding: '3rem', width: '100%', maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#333', marginBottom: '0.5rem' }}>
            Endpoint Testing Platform
          </h1>
          <p style={{ color: '#6c757d', margin: 0 }}>Admin Login</p>
        </div>

        {error && (
          <div className="alert alert-danger" style={{ marginBottom: '1.5rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="api_key" style={{ fontWeight: 600 }}>Admin API Key</label>
            <input
              type="password"
              id="api_key"
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
              required
              placeholder="Enter your API key"
              autoFocus
              style={{ marginTop: '0.4rem' }}
            />
          </div>

          <button
            type="submit"
            disabled={loading || !apiKey.trim()}
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '1rem', padding: '0.65rem' }}
          >
            {loading ? 'Verifying…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
